<script lang="ts" setup>
import {useWindowSize} from "@vueuse/core";
import {useNavTabs, type TabItem} from "~/composables/useNavTabs";
import { RoleEnum } from "~/types/User";
import ProfileMenuModal from "~/components/custom-ui/ProfileMenuModal.vue";
import {Button} from "~/components/ui/button";
const userStore = useUserStore()
const {width} = useWindowSize()
const route = useRoute()
const navTabs = useNavTabs()

const isHidden = computed(() => {
    return width.value && width.value > 1024
})

const tabList = navTabs.value.filter(item => item.role.includes(userStore.currentRole as RoleEnum) && item.show_in_mobile)
const isCurrentRoute = (item: TabItem) => {
	return route.path === item.path || item.child_pages.includes(route.path)
}

</script>

<template>
	<ClientOnly>
		<Teleport to="#teleports">
			<div v-if="!isHidden && userStore.isAuthenticated && userStore.currentRole"
				class="grid md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-[0_0_5px_0_rgba(0,0,0,0.07)] z-50" :class="{
					'grid-cols-3': tabList.length === 3,
					'grid-cols-4': tabList.length === 4,
					'grid-cols-5': tabList.length === 5,
				}">
				<template v-for="item in tabList">
					<ProfileMenuModal v-if="item.name === 'My profile'">
						<Button
							class="p-2 flex-col h-auto items-center bg-white text-gray-500 rounded-md hover:bg-stroke relative"
							:class="{ 'text-primary-500': isCurrentRoute(item) }">
								<Icon v-if="item.icon" :name="item.icon" size="24px" class="mb-1" />
								<span class="text-[10px] sm:text-xs">{{ $t(item.name) }}</span>
						</Button>
					</ProfileMenuModal>
					
					<Button
					v-else
						class="p-2 flex-col h-auto items-center bg-white text-gray-500 rounded-md hover:bg-stroke relative"
						:class="{ 'text-primary-500': isCurrentRoute(item) }" as-child>
						<NuxtLink :to="item.path">
							<span v-if="userStore.unreadResponsesCount && item.name === 'Chats'"
								class="absolute top-2 left-[50%] badge bg-red-500 text-[10px] sm:text-xs leading-none text-white rounded-full py-0.5 px-1 z-10">{{
                                    userStore.unreadResponsesCount }}</span>
							<Icon v-if="item.icon" :name="item.icon" size="24px" class="mb-1" />
							<span class="text-[10px] sm:text-xs">{{ $t(item.name) }}</span>
						</NuxtLink>
					</Button>
				</template>
			</div>
		</Teleport>
	</ClientOnly>
</template>



<style></style>